import React, { useContext, useEffect, useState } from "react";
import Header from "./Navbar";
import Navigation from "./Navigation";
import { TailSpin } from "react-loader-spinner";
import { message } from "antd";
import { ethers } from "ethers";
import { AppState } from "../App";
import Fee from "../artifacts/contracts/Fee.sol/Fee.json";
import { useWeb3 } from "../contexts/Web3Context";

const Red = () => {
  const useAppState = useContext(AppState);
  const {
    staticContract,
    walletAddress,
    isContractReady,
    signer,
    contractAddresses,
    provider,
  } = useWeb3();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [place, setPlace] = useState("");
  const [addr, setAddr] = useState("");
  const [data, setData] = useState([[], []]);
  const [percent, setPercent] = useState("");
  const [place2, setPlace2] = useState("");

  const [royaltySplit, setRoyaltySplit] = useState("");
  const [currentRoyaltySplit, setCurrentRoyaltySplit] = useState("");

  useEffect(() => {
    let mounted = true;
    async function getData() {
      if (!isContractReady || !provider) {
        console.log("Waiting for contract initialization...");
        return;
      }
      try {
        const feeContract = new ethers.Contract(
          contractAddresses.fee,
          Fee.abi,
          provider
        );

        let addrs = [];
        let percents = [];
        for (let i = 0; i < 4; i++) {
          let curFee = await feeContract.receivers(i);
          let curPercent = await feeContract.percents(i);
          addrs.push(curFee);
          percents.push(Number(curPercent));
        }

        // Get current royalty split
        const currentSplit = await feeContract.royaltySplitPercent();

        if (!mounted) return;
        setData([addrs, percents]);
        setCurrentRoyaltySplit(currentSplit.toString());
      } catch (error) {
        console.error("Error fetching data:", error);
        message.error("Failed to fetch data. Please try refreshing the page.");
      }
    }
    getData();
    return () => {
      mounted = false;
    };
  }, [isContractReady, provider, contractAddresses.fee]);

  const changeReceiver = async () => {
    setLoading(true);
    try {
      if (!signer) throw new Error("Signer not available");
      const contract = new ethers.Contract(
        contractAddresses.fee,
        Fee.abi,
        signer
      );
      let tx = await contract.changeAddr(addr, place);
      await tx.wait();
      message.success("Successfully Changed");
    } catch (error) {
      message.error(error.reason || "Failed to change receiver");
    }
    setLoading(false);
  };
  const changePercent = async () => {
    setLoading2(true);

    if(percent > 85 || percent < 1) {
      message.error("Percent must be between 1 and 85");
      setLoading2(false);
      return;
    }

    try {
      if (!signer) throw new Error("Signer not available");
      const contract = new ethers.Contract(
        contractAddresses.fee,
        Fee.abi,
        signer
      );
      let tx = await contract.changePercent(percent, place2);
      await tx.wait();
      message.success("Successfully Changed");
    } catch (error) {
      message.error(error.reason || "Failed to change percent");
    }
    setLoading2(false);
  };

  const updateRoyaltySplit = async () => {
    setLoading3(true);
    try {
      if (!signer) throw new Error("Signer not available");
      const contract = new ethers.Contract(
        contractAddresses.fee,
        Fee.abi,
        signer
      );
      let tx = await contract.setRoyaltySplit(royaltySplit);
      await tx.wait();
      // Update the current split after successful change
      const newSplit = await contract.royaltySplitPercent();
      setCurrentRoyaltySplit(newSplit.toString());
      message.success("Successfully Updated Royalty Split");
    } catch (error) {
      message.error(error.reason || "Failed to update royalty split");
    }
    setLoading3(false);
  };

  return (
    <>
      <img
        src="bgimg.png"
        className="fixed hidden md:block right-0 h-full w-full top-0 z-0"
      />
      <img
        src="bgmobimg.png"
        className="fixed h-full w-full left-0 md:top-0 block md:hidden top-0 z-0"
      />

      <div className="pb-4 text-black dark:text-white transition-colors duration-1000 min-h-screen relative">
        <Header />

        <div className="flex justify-center w-full px-4 mt-6">
          <div className="w-full md:w-3/4">
            <Navigation />
          </div>
        </div>

        {walletAddress.toLowerCase() ==
        process.env.REACT_APP_ADMIN_WALLET.toLowerCase() ? (
          // {true ?
          <div className="w-full">
            <div className="w-full flex flex-col items-center">
              <div className="flex flex-col w-full md:w-3/4 mt-8 px-4 md:px-0">
                {data[0].map((e, i) => {
                    if(i === 0) return null;
                  return (
                    <span className="font-mono font-semibold" key={i}>
                      {i}: {Number(data[1][i])}% : {e}
                    </span>
                  );
                })}
              </div>
            </div>

            <div className="w-full flex flex-col items-center px-4 md:px-0">
              <div className="flex flex-col w-full md:w-3/4 mt-4">
                <span className="font-mono font-semibold">Change Address</span>
                <input
                  value={addr}
                  onChange={(e) => setAddr(e.target.value)}
                  placeholder="Enter Address"
                  className="font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm"
                />
                <input
                  value={place}
                  onChange={(e) => setPlace(e.target.value)}
                  placeholder="Enter Place (1, 3)"
                  className="font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm"
                />
                <button
                  onClick={changeReceiver}
                  className="bg-green-500 mt-2 text-white w-full px-4 py-2 text-sm font-bold rounded-sm flex justify-center items-center"
                >
                  {loading ? (
                    <TailSpin height={16} color="white" />
                  ) : (
                    <p>Change</p>
                  )}
                </button>
              </div>
              <div className="flex flex-col w-full md:w-3/4 mt-4">
                <span className="font-mono font-semibold">Change Percent</span>
                <input
                  value={percent}
                  onChange={(e) => setPercent(e.target.value)}
                  placeholder="Enter Percent"
                  className="font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm"
                />
                <input
                  value={place2}
                  onChange={(e) => setPlace2(e.target.value)}
                  placeholder="Enter Place (1, 3)"
                  className="font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm"
                />
                <button
                  onClick={changePercent}
                  className="bg-green-500 mt-2 text-white w-full px-4 py-2 text-sm font-bold rounded-sm flex justify-center items-center"
                >
                  {loading2 ? (
                    <TailSpin height={16} color="white" />
                  ) : (
                    <p>Change</p>
                  )}
                </button>
              </div>
            </div>

            {/*<div className="flex flex-col w-full md:w-3/4 mt-4 mx-auto">
                <span className='font-mono font-semibold'>Royalty Split Percentage</span>
                <span className='font-mono mt-2'>Current: {Number(currentRoyaltySplit) + 10}%</span>
                <input 
                    value={royaltySplit} 
                    onChange={(e) => setRoyaltySplit(e.target.value)} 
                    placeholder='Enter New Royalty Split Percentage' 
                    type="number"
                    min="0"
                    max="100"
                    className='font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm' 
                />
                <button 
                    onClick={updateRoyaltySplit} 
                    className='bg-green-500 mt-2 text-white w-full px-4 py-2 text-sm font-bold rounded-sm flex justify-center items-center'
                >
                    {loading3 ? <TailSpin height={16} color='white' /> : <p>Update Royalty Split</p>}
                </button>
            </div>*/}

          </div>
        ) : null}
      </div>
    </>
  );
};

export default Red;
